module.exports = __webpack_public_path__ + "img/right-arm.95eac70d.png";